import * as Slider from '@radix-ui/react-slider'

export default function RangeSlider({
  value,
  min,
  max,
  onChange,
  marker,
  minLabel,
  maxLabel,
  ariaLabel,
}: {
  value: number
  min: number
  max: number
  onChange: (value: number) => void
  marker?: number
  minLabel?: string
  maxLabel?: string
  ariaLabel?: string
}) {
  const ticks: number[] = []
  for (let tick = min + 10; tick < max; tick += 10) ticks.push(tick)

  const THUMB = 24
  const thumbLeft = (v: number) => {
    const fraction = (v - min) / (max - min)
    return `calc(${fraction * 100}% + ${(0.5 - fraction) * THUMB}px)`
  }

  return (
    <div>
      <Slider.Root
        value={[value]}
        min={min}
        max={max}
        step={1}
        onValueChange={([next]) => onChange(next)}
        className="relative flex h-6 w-full cursor-pointer touch-none items-center select-none"
      >
        <Slider.Track className="relative h-2 w-full rounded-full bg-gray-300">
          <Slider.Range className="absolute h-full rounded-full bg-blue-700" />
          {ticks.map((tick) => (
            <div
              key={tick}
              className="absolute top-0 h-full w-0.5 -translate-x-1/2 bg-white"
              style={{ left: thumbLeft(tick) }}
            />
          ))}
          {marker !== undefined && (
            <div
              className="absolute top-1/2 z-10 size-3 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white bg-yellow-600"
              style={{ left: thumbLeft(marker) }}
            />
          )}
        </Slider.Track>
        <Slider.Thumb
          aria-label={ariaLabel}
          className="block size-6 rounded-full border-2 border-white bg-blue-700 shadow-sm transition-shadow focus:ring-2 focus:ring-blue-700 focus:outline-none"
        />
      </Slider.Root>
      {(minLabel || maxLabel) && (
        <div className="mt-1 flex justify-between text-2xs text-gray-600">
          <span>{minLabel}</span>
          <span>{maxLabel}</span>
        </div>
      )}
    </div>
  )
}
